// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createCreditMemo} from '../../shared/repositories';
import {getCreditMemoReportCriteria} from '../../shared/services/reports';

export const createCreditMemoReport = (reportLength, gridApi) =>
    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const creditMemoReportState = getState().reports.creditMemo;

            const postArgs = getCreditMemoReportCriteria(creditMemoReportState);

            const data = await createCreditMemo(postArgs);

            if (reportLength) {

                gridApi.deselectAll();
                dispatch({
                    showSelectAll: true,
                    type: actions.UPDATE_CREDIT_MEMO_SHOW_SELECT_ALL
                });

            }

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_CREDIT_MEMO_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/report.js